// Allows blockly to create data dictionary entries without adding an actual visible component to a
// relation's form.  This avoids a problem where a relation property needs to be saved to the
// server as part of patch/post, but does not exist in the datadictionary (and therefore fails
// server validation) because no blockly form ever references it.

export default function InvisibleElement() {
    return null;
}
